/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_ErrorInputs */

const en_google_drive_error = /** @type {(inputs: Google_Drive_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not open Google Drive. Try again or reconnect your account in Integrations.`)
};

const es_google_drive_error = /** @type {(inputs: Google_Drive_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo abrir Google Drive. Inténtalo de nuevo o vuelve a conectar tu cuenta en Integraciones.`)
};

/**
* | output |
* | --- |
* | "Could not open Google Drive. Try again or reconnect your account in Integrations." |
*
* @param {Google_Drive_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_error = /** @type {((inputs?: Google_Drive_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_error(inputs)
	return en_google_drive_error(inputs)
});